import React, { useState } from "react";
import { Input } from "@/components/ui/input";
import { type TipoMovimiento } from "@/lib/api";
import { ListToolbar } from "@/components/ListNewButton";

// TODO: Replace with API call when backend is ready
// API Base URL: const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:8000/api';
/*
const fetchTiposMovimiento = async () => {
  const response = await fetch(`${API_BASE_URL}/opciones/tipos-movimiento/`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${getAuthToken()}`
    }
  });
  const data = await response.json();
  // Expected JSON response: TipoMovimiento[]
  // Each tipo should have: { codigo, nombre, descripcion }
  return data;
};
*/

interface MovimientosListadoProps {
  tipos: TipoMovimiento[];
  onEdit: (tipo: TipoMovimiento) => void;
  onNew?: () => void;
}

export function MovimientosListado({ tipos = [], onEdit, onNew }: MovimientosListadoProps) {
  const [searchQuery, setSearchQuery] = useState("");

  const filteredTipos = searchQuery.trim()
    ? (tipos || []).filter(tipo =>
      tipo.nombre.toLowerCase().includes(searchQuery.toLowerCase()) ||
      tipo.codigo.toLowerCase().includes(searchQuery.toLowerCase())
    )
    : (tipos || []);

  return (
    <div className="space-y-4">
      <ListToolbar onNew={onNew}>
        <Input
          type="text"
          placeholder="Buscar por nombre o código..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="w-full"
        />
      </ListToolbar>

      {filteredTipos.length > 0 ? (
        <div className="border border-input rounded-lg overflow-hidden">
          <table className="w-full">
            <thead className="bg-muted">
              <tr>
                <th className="text-left py-3 px-4 text-sm font-medium">Código</th>
                <th className="text-left py-3 px-4 text-sm font-medium">Nombre</th>
                <th className="text-left py-3 px-4 text-sm font-medium">Moneda</th>
                <th className="text-left py-3 px-4 text-sm font-medium">Descripción</th>
              </tr>
            </thead>
            <tbody>
              {filteredTipos.map((tipo) => (
                <tr
                  key={tipo.codigo}
                  className="border-t border-input hover:bg-muted/50 cursor-pointer transition-colors"
                  onClick={() => onEdit(tipo)}
                >
                  <td className="py-3 px-4 text-sm">{tipo.codigo}</td>
                  <td className="py-3 px-4 text-sm font-medium">{tipo.nombre}</td>
                  <td className="py-3 px-4 text-sm">{tipo.moneda === "USD" ? "USD" : "ARS"}</td>
                  <td className="py-3 px-4 text-sm text-muted-foreground">{tipo.descripcion}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="text-center py-8 text-muted-foreground">
          {searchQuery.trim() ? "No se encontraron resultados" : "No hay datos para mostrar"}
        </div>
      )}
    </div>
  );
}